import { useLang } from '../LangContext';
import translations from '../i18n';

export default function Intro() {
  const { lang } = useLang();
  const t = translations[lang];
  const { intro, marquee } = t;

  return (
    <section id="about" style={{ background: '#B5B7B9' }}>
      <div className="marquee-wrap">
        <div className="marquee-track">
          {[...Array(2)].map((_, rep) => (
            <span key={rep} style={{display:'contents'}}>
              <span>{marquee[0]}</span><span className="sep">◆</span>
              <span>{marquee[1]}</span><span className="sep">◆</span>
              <span>{marquee[2]}</span><span className="sep">◆</span>
            </span>
          ))}
        </div>
      </div>

      <div style={{ maxWidth: '900px', margin: '0 auto', padding: '100px 40px' }}>
        {intro.text.split('\n\n').map((para, i) => (
          <p key={i} className={`reveal delay-${i + 1}`} style={{
            fontFamily: 'var(--font-body)', fontSize: 'clamp(1rem, 1.6vw, 1.25rem)',
            lineHeight: 1.9, color: '#111', marginBottom: '28px',
          }}>{para}</p>
        ))}

        <div className="reveal delay-3" style={{ marginTop: '64px', display: 'flex', flexDirection: 'column', gap: '0' }}>
          {[intro.claim1, intro.claim2].map((claim, i) => (
            <div key={i} style={{ padding: '28px 0', borderBottom: '1px solid rgba(0,0,0,0.12)', display: 'flex', alignItems: 'flex-start', gap: '24px' }}>
              <span style={{ fontFamily: 'var(--font-title)', color: 'var(--red)', fontSize: '1.2rem', flexShrink: 0, marginTop: '2px' }}>→</span>
              <p style={{ fontFamily: 'var(--font-body)', fontWeight: 700, fontSize: 'clamp(0.95rem, 1.3vw, 1.1rem)', lineHeight: 1.6, color: '#111' }}>{claim}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
